import {
	GetPrivacyPolicyLink,
	GetPrivacyPolicyLinkModel,
	GetPrivacyPolicyLinkParams,
} from 'domain/usecases';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

export class RemoteGetPrivacyPolicyLink implements GetPrivacyPolicyLink {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetPrivacyPolicyLinkModel>,
	) {}

	async get(params?: GetPrivacyPolicyLinkParams): Promise<GetPrivacyPolicyLinkModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
